import * as actions from "./actionTypes";

const initialData = {
  loaderCompetencyQuestion: false,
  competencyQuestion: null,
  competencyQuestionFalla: null,
  saveLoaderCompetencyQuestion: false,
  competencyQuestionFormError:null
};

export default function CompetencyQuestionReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_COMPETENCY_QUESTIONS:
      return { ...state, loaderCompetencyQuestion: action.payload };

    case actions.GET_COMPETENCY_QUESTIONS:
      return { ...state, competencyQuestion: action.payload };

    case actions.COMPETENCY_QUESTIONS_FALLA:
      return { ...state, competencyQuestionFalla: action.payload };

    case actions.SAVE_LOADER_COMPETENCY_QUESTIONS:
      return { ...state, saveLoaderCompetencyQuestion: action.payload };

    case actions.FORM_COMPETENCY_QUESTIONS_FAIL:
      return { ...state, competencyQuestionFormError: action.payload };
      
    default:
      return state;
  }
}
